import React from "react"
import { createIcon } from "@chakra-ui/icons"

export const Expand = createIcon({
  displayName: "Expand",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.04999 4.67499C4.84288 4.67499 4.67499 4.84288 4.67499 5.04999V10.36C4.67499 10.5671 4.84288 10.735 5.04999 10.735C5.25709 10.735 5.42499 10.5671 5.42499 10.36V5.94621L10.0946 10.6249C10.2409 10.7715 10.4783 10.7717 10.6249 10.6254C10.7715 10.4791 10.7717 10.2417 10.6254 10.0951L5.96441 5.42499H10.36C10.5671 5.42499 10.735 5.25709 10.735 5.04999C10.735 4.84288 10.5671 4.67499 10.36 4.67499H5.04999ZM13.3651 13.3546C13.5117 13.2083 13.7491 13.2085 13.8954 13.3551L18.565 18.0338V13.62C18.565 13.4129 18.7329 13.245 18.94 13.245C19.1471 13.245 19.315 13.4129 19.315 13.62V18.93C19.315 19.1371 19.1471 19.305 18.94 19.305H13.63C13.4229 19.305 13.255 19.1371 13.255 18.93C13.255 18.7229 13.4229 18.555 13.63 18.555H18.0256L13.3646 13.8849C13.2183 13.7383 13.2185 13.5009 13.3651 13.3546Z"
    />
  ),
})
